import { Injectable, Inject } from '@angular/core';

@Injectable()
export class SecurityService {
  constructor(
    @Inject('$state') private $state,
  ) {}
}



// WEBPACK FOOTER //
// ../node_modules/angular2-template-loader!./ng2/shared/services/security.service.ts